import Matter from "matter-js";

let floatyBubbles = {
  // customizable options (passed into init function)
  options: {
    canvasSelector: "", // to find <canvas> in DOM to draw on
    radiusRange: [50, 100], // random range of body radii
    xVarianceRange: [-0.5, 0.5], // random range of x velocity scaling on bodies
    yVarianceRange: [0.5, 1.5], // random range of y velocity scaling on bodies
    airFriction: 0.03, // air friction of bodies
    opacity: 1, // opacity of bodies
    collisions: true, // do bodies collide or pass through
    scrollVelocity: 0.025, // scaling of scroll delta to velocity applied to bodies
    pixelsPerBody: 50000, // viewport pixels required for each body added
    colors: ["#000000","#333333","#666666", "#0000eb"]
  },

  // throttling intervals (in ms)
  scrollDelay: 100,
  resizeDelay: 500,

  // throttling variables and timeouts
  lastOffset: undefined,
  scrollTimeout: undefined,
  resizeTimeout: undefined,
  currentWidth : window.innerWidth,

  // Matter.js objects
  engine: undefined,
  render: undefined,
  runner: undefined,
  bodies: undefined,

  // kicks things off
  init(options) {

    let photoContainer = document.querySelector(".photo .image-container");
    let photoWidth = photoContainer.offsetWidth;
    let photoHeight = photoContainer.offsetHeight;
    let xme = photoWidth / 2;
    let yme = photoHeight / 2;
    let vmin = Math.min(photoWidth, photoHeight);

    // override default options with incoming options
    this.options = Object.assign({}, this.options, options);

    this.lastOffset = window.pageYOffset;
    this.scrollTimeout = null;
    this.resizeTimeout = null;

    // engine
    this.engine = Matter.Engine.create({ // https://github.com/liabru/matter-js/issues/992#issuecomment-813411199
      positionIterations: 100,
      velocityIterations: 10
    });
    //this.engine.world.gravity.y = 1;
    const that = this.engine;

    // Src : https://github.com/catwalkghost/device-orientation-split
    const bannerText = "Surprise";
    const bannerInnerHtml = `<div id="banner">${bannerText}</div>`

    if (window.DeviceMotionEvent && typeof window.DeviceMotionEvent.requestPermission === "function") {
      const banner = document.createElement("div");
      banner.id = "banner";
      banner.innerHTML = bannerText;
      banner.onclick = getAccelerometer;
      document.getElementById("device-motion").appendChild(banner);
    }

    function getAccelerometer() {
      document.getElementById("banner").style.display = "none";
      window.DeviceMotionEvent.requestPermission()
      .then(response => {
        if (response === "granted") {
          //console.log("DeviceMotion permissions granted")
          window.addEventListener("deviceorientation", updateBubblesWorld);
        } else {
          console.log("DeviceMotion permissions not granted")
        }
      })
      .catch(e => console.error(e));
    };

    function updateBubblesWorld(evt) {
      const rotRate = evt.gamma;
      if(rotRate > 30){
        //console.log(rotRate);
        that.world.gravity.x = 1;
      } else if(rotRate < -30) {
        that.world.gravity.x = -1;
        //console.log(rotRate);
      } else {
        that.world.gravity.x = 0;
        //console.log(rotRate);
      }
    }

    let MouseConstraint = Matter.MouseConstraint, Mouse = Matter.Mouse;

    const here = document.getElementById("me");
    this.render = Matter.Render.create({
      element: here,
      engine: this.engine,
      options: {
        pixelRatio: "auto",
        width: photoWidth,
        height: photoHeight,
        wireframes: false,
        background: "transparent"
      }
    });

    Matter.Render.run(this.render);
    //Matter.Engine.run(this.engine);

    // runner
    this.runner = Matter.Runner.create();
    Matter.Runner.run(this.runner, this.engine);

    Matter.World.add(this.engine.world, [
      // walls
      Matter.Bodies.rectangle(xme, -25, photoWidth, 50, { isStatic: true, render: {
        opacity: "0"
      } }),
      Matter.Bodies.rectangle(xme, photoHeight + 25, photoWidth, 50, { isStatic: true,  render: {
        opacity: "0"
      }}),
      Matter.Bodies.rectangle(photoWidth + 25, yme, 50, photoHeight, { isStatic: true, render: {
        opacity: "0"
      }}),
      Matter.Bodies.rectangle(-25, yme, 50, photoHeight, { isStatic: true, render: {
        opacity: "0"
      }}),
      //stack
    ]);

    this.bodies = [];
    let num = (Math.min(photoWidth, 1200)) / 9;
    //console.log(num);

    for (let i = 0; i < num; i++) {
      let radius = Math.round(10 + (Math.random() * vmin / 15));

      this.bodies.push(Matter.Bodies.circle(
        Math.random() * photoWidth,
        Math.random() * photoHeight / 4,
        radius, {
          render: {
            fillStyle: ["#000000", "#666666", "#0000eb"][Math.round(Math.random() * 3 - 0.5)]
          }
        }
      ));
    }

    Matter.World.add(this.engine.world, this.bodies)

    // Add mouse control
    const mouse = Matter.Mouse.create(this.render.canvas),
    mouseConstraint = MouseConstraint.create(this.engine, {
      mouse: mouse,
      constraint: {
        stiffness: 0.2,
        render: { visible: false }
      }
    });

    // Mimic draggable cursor
    Matter.Events.on(mouseConstraint, "mousemove", function (event) {
      const allBodies = Matter.Composite.allBodies(that.world);
      const bodies = Matter.Query.point(allBodies, event.mouse.position) || 0;
      if (bodies.length !== 0) {
        here.style.cursor = "grab";
      } else {
        here.style.cursor = "auto";
      }
    });

    // Scrolling Broken? Easily fixed - https://blog.alexandergottlieb.com/matter-js-the-missing-tutorial-70aafc06b167
    mouseConstraint.mouse.element.removeEventListener("mousewheel", mouseConstraint.mouse.mousewheel, { passive: true });
    mouseConstraint.mouse.element.removeEventListener("DOMMouseScroll", mouseConstraint.mouse.mousewheel, { passive: true });

    Matter.World.add(this.engine.world, mouseConstraint);
    // Keep the mouse in sync with rendering
    this.render.mouse = mouse;
    // Events
    window.addEventListener("scroll", this.onScrollThrottled.bind(this));
    // window.addEventListener("resize", this.onResizeThrottled.bind(this));
  },

  // stop all the things
  shutdown() {
    this.render.canvas.remove();
    this.render.canvas = null;
    this.render.context = null;
    this.render.textures = {};
    Matter.World.remove(this.engine.world, Matter.Bodies.circle);
    Matter.Render.stop(this.render);
    Matter.Runner.stop(this.runner);
    //console.log("shutdown");
    window.removeEventListener("scroll", this.onScrollThrottled);
    // window.removeEventListener("resize", this.onResizeThrottled);
  },

  // Random number generator
  randomize(range) {
    let [min, max] = range;
    return Math.random() * (max - min) + min;
  },

  // Create body with some random parameters
  createBody(photoWidth, photoHeight) {

    let x = this.randomize([0, photoWidth]);
    let y = this.randomize([0, photoHeight]);
    let radius = this.randomize(this.options.radiusRange);
    let color = this.options.colors[this.bodies.length % this.options.colors.length];

    return Matter.Bodies.circle(x, y, radius, {
      render: {
        fillStyle: color,
        opacity: this.options.opacity
      },
      frictionAir: this.options.airFriction,
      collisionFilter: {
        group: this.options.collisions ? 1 : -1
      }
    });
  },

  // Enforces throttling of scroll handler
  onScrollThrottled() {
    if (!this.scrollTimeout) {
      this.scrollTimeout = setTimeout(this.onScroll.bind(this), this.scrollDelay);
    }
  },

  // Applies velocity to bodies based on scrolling with some randomness
  onScroll() {
    this.scrollTimeout = null;
    let delta = (this.lastOffset - window.pageYOffset) * this.options.scrollVelocity;
    this.bodies.forEach((body) => {
        Matter.Body.setVelocity(body, {
        x: body.velocity.x + delta * this.randomize(this.options.xVarianceRange),
        y: body.velocity.y + delta * this.randomize(this.options.yVarianceRange)
      });
    });
    this.lastOffset = window.pageYOffset;
  },

  // enforces throttling of resize handler
  // onResizeThrottled() {
  //   if (!this.resizeTimeout) {
  //     this.resizeTimeout = setTimeout(this.onResize.bind(this), this.resizeDelay);
  //   }
  // },

  /* Restart everything with the new viewport size
  Src : https://titanwolf.org/Network/Articles/Article?AID=488d4b0c-53df-4102-99af-6983a915ea8d */
  // onResize() {
  //   if (this.currentWidth == window.innerWidth || document.getElementById("me") == null) { return; }
  //   this.currentWidth = window.innerWidth;
  //   this.shutdown();
  //   this.init();
  //   if (document.contains(document.getElementById("banner"))) {
  //     document.getElementById("banner").remove();
  //   }
  // }
};

// wait for DOM to load
window.addEventListener("load", () => {});

export default floatyBubbles;
